import React from "react";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPage({ onClose }) {
    return (
        <div className="fixed inset-0 z-[600] bg-white overflow-auto" data-testid="privacy-page">
            <div className="max-w-3xl mx-auto p-5 md:p-10">
                <button className="btn-ghost !py-2 !px-4 mb-6" onClick={onClose} data-testid="privacy-back">
                    <ArrowLeft className="w-4 h-4" /> Back
                </button>
                <h1 className="font-display font-extrabold text-3xl md:text-4xl text-[#1a1e2c] mb-2">
                    Privacy Policy
                </h1>
                <p className="text-slate-500 mb-8">Last updated: February 2026</p>

                <div className="prose prose-slate max-w-none font-body space-y-5 text-[15px] leading-relaxed text-slate-700">
                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">Who we are</h2>
                        <p>
                            Dailyworkjobs (“we”, “us”) is a job-discovery service that helps people in the USA and Canada find hourly, staffing, and daily-wage work.
                            We are <b>not an employer</b>; we do not hire, pay, or manage any of the jobs listed on this site. All listings are aggregated from public job feeds
                            (Adzuna, Jooble, Careerjet, USAJobs, and Google Jobs via SerpAPI) and link to the original employer or job-board site.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">What we collect</h2>
                        <ul className="list-disc pl-6 space-y-1">
                            <li>Your <b>name, mobile number and email</b> when you use our 1-tap apply form.</li>
                            <li>An <b>approximate location</b> only if you press “Jobs near me” and grant permission; we use it once to center the map.</li>
                            <li>Basic technical data (IP address, browser user-agent) to prevent abuse.</li>
                        </ul>
                        <p>We do <b>not</b> ask for your resume, government ID, or payment details.</p>
                    </section>

                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">How we use it</h2>
                        <ul className="list-disc pl-6 space-y-1">
                            <li>To pass your name, mobile and email to the employer you selected, so they can review your interest and contact you.</li>
                            <li>To send you occasional updates about similar jobs in your area (you can opt out at any time by emailing us).</li>
                            <li>To improve the site and prevent spam.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">Consent &amp; withdrawal</h2>
                        <p>
                            Before we save or share your details, you must tick the consent checkbox in the apply form. You can withdraw consent at any time by emailing
                            <a href="mailto:sajintexas@gmail.com" className="text-[#e85812] underline"> sajintexas@gmail.com</a> and we will delete your data within 30 days.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">Your rights (CCPA &amp; PIPEDA)</h2>
                        <p>
                            Residents of California (CCPA) and Canada (PIPEDA) have the right to know what personal information we hold about them, to access or correct it,
                            to have it deleted, and to opt out of any “sale” of personal information. We do <b>not</b> sell personal information. To exercise any of these rights, email us.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">Where listings come from</h2>
                        <p>
                            Job listings are sourced in real time from Adzuna, Jooble, Careerjet, USAJobs, and Google Jobs (via SerpAPI). We filter results to hourly / daily-wage roles only.
                            When you click “Apply” we redirect you to the original job posting on the employer’s site or partner job board (e.g. Snagajob, Spherion, Indeed).
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">Trademarks</h2>
                        <p>
                            All company names, logos and trademarks appearing on Dailyworkjobs belong to their respective owners.
                            Dailyworkjobs is not affiliated with, endorsed by, or sponsored by any of the listed employers.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">Data retention</h2>
                        <p>We keep lead records for up to 24 months, unless you ask us to delete them sooner.</p>
                    </section>

                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">Children</h2>
                        <p>Dailyworkjobs is intended for users 16+. We do not knowingly collect data from anyone under 16.</p>
                    </section>

                    <section>
                        <h2 className="font-display font-bold text-xl text-[#333A56] mb-2">Contact</h2>
                        <p>
                            Questions or requests? Email <a href="mailto:sajintexas@gmail.com" className="text-[#e85812] underline">sajintexas@gmail.com</a>.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
}
